/* file description */

// import { compose } from '@cui/corteza-js';
import { message } from 'antd';
import { useRef } from 'react';
import { EMPTY_MODULE_ID } from './consts';
import type { GetTransformParams, PageNavigationInfo, UseXMRequestProp, RecordValueType } from './type';
import getAssetRecord from '../service/getAssetRecord';
import moment from 'moment';
import _ from 'lodash';
import { composeRecord } from '@/utils';

export const useRequestProp: UseXMRequestProp = ({
  // request,
  FetchAPI,
  dataVersion,
  openVersion,
  tableBaseMode,
}) => {
  const pageNavigationRef = useRef<PageNavigationInfo[]>([]);
  const tableDataSourceRef = useRef<Array<Record<string, any>>>([]);
  if (tableBaseMode === 'add') {
    return {
      currentTableDataSource: tableDataSourceRef.current,
      mergeRequest: null,
    };
  }
  return {
    currentTableDataSource: tableDataSourceRef.current,
    mergeRequest: async (params, sort) => {
      if (!params?.moduleInfo?.fields) {
        return;
      }
      const resultParams: GetTransformParams = {
        version: dataVersion,
        openVersion,
        namespaceID: params.namespaceID,
        moduleID: params.moduleID,
        filter: '',
        limit: params.pageSize || 20,
        pageCursor:
          params.current === 1 ? '' : pageNavigationRef.current[params.current! - 1]?.cursor,
        incPageNavigation: params.current === 1,
        incTotal: params.current === 1,
        ...(params.requestParams || {}),
      };
      // 处理filter参数转换的
      for (const paramKey in params) {
        if (['current', 'pageSize', 'namespaceID', 'moduleID', 'filter', 'moduleInfo', 'requestParams'].includes(paramKey)) {
          continue;
        }
        if (params[paramKey]) {
          const field = params?.moduleInfo?.fields?.find((item: any) => item.name === paramKey);
          let condition = '';
          if (['Reference', 'AreaSelect', 'AseetCheckbox', 'AseetRadio'].includes(field?.kind)) {
            if (field?.bizConfig?.isMulti) {
              let targetSql = '';
              if (Array.isArray(params[paramKey])) {
                targetSql = params[paramKey]?.map((fV: any) => `'${fV}'`).join(',');
              } else {
                targetSql = params[paramKey].split(',')?.map((fV: any) => `'${fV}'`).join(',');
              }
              condition = `${paramKey} in (${targetSql})`;
            } else {
              condition = `${paramKey} = '${params[paramKey]}'`;
            }
          } else if (['DateTime', 'AssetDateTime'].includes(field?.kind)) {
            let value = params[paramKey];
            if (!_.isArray(value)) {
              value = [value, value];
            }
            condition = `${paramKey} >= '${moment(value[0]).format('YYYY-MM-DD HH:mm:ss')}.000' AND ${paramKey} <= '${moment(value[1]).format('YYYY-MM-DD HH:mm:ss.999')}'`;
          } else if (_.isNumber(params[paramKey])) {
            condition = `${paramKey} = ${params[paramKey]}`;
          } else {
            condition = `${paramKey} ILIKE '%${params[paramKey]}%'`;
          }
          resultParams.filter = resultParams.filter ? `${resultParams.filter} AND ${condition}` : `${condition}`;
        }
      }

      // 处理排序字段转换的
      // if (Object.keys(sort)?.length > 0) {
      //   resultParams.sort =
      //     Object.values(sort)[0] === 'ascend'
      //       ? Object.keys(sort)[0]
      //       : `${Object.keys(sort)[0]} DESC`;
      // }
      if (sort?.field) {
        resultParams.sort = sort.order === 'ascend' ? (sort.field || '') : `${sort.field} DESC`;
      }


      // 处理外部传入的params
      if (params?.filter) {
        resultParams.filter =
          resultParams.filter?.length < 1
            ? params.filter
            : `${resultParams.filter} AND ${params.filter}`;
      }
      const moduleInfo = params?.moduleInfo;
      if (isEmptyModule(moduleInfo)) return { data: [] };
      // const module = moduleInfo.clone();
      const module = moduleInfo;
      try {
        const res: RecordValueType = await getAssetRecord({ FetchAPI, resultParams, params });
        const { set = [], filter: pFilter } = res || {};
        // const records = set.map((item) => new compose.Record(module, item));
        const records = set.map((item) => composeRecord(item));
        const data = records.map((record) => (
          {
            ...record,
            // RECORD: record,
          }));
        // 记录一下，备用
        tableDataSourceRef.current = data || [];
        if (params.current === 1) {
          pageNavigationRef.current = pFilter.pageNavigation || [];
        }
        return {
          success: true,
          data: data || [],
          pFilter,
          total: pFilter.total || data?.length,
        };
      } catch (error) {
        message.error(`获取列表数据失败 - moduleID: ${params.moduleID}`);
        return {
          success: false,
          data: [],
          total: 0,
        };
      }
    },
  };
};

// 判断是否为空module
export const isEmptyModule = (module: any) => {
  return module.moduleID === EMPTY_MODULE_ID;
};
